import React from 'react';

export const useChartOnReady = () => {
  const onReadyCallbacksRef = React.useRef<Array<(_series: any[]) => void>>([]);

  const registerCallback = React.useCallback((_callback: (_series: any[]) => void) => {
    onReadyCallbacksRef.current.push(_callback);
  }, []);

  const executeCallbacks = React.useCallback((series: any[]) => {
    if (series.length > 0) {
      const lastSeries = series[series.length - 1];
      lastSeries.events.once('datavalidated', () => {
        onReadyCallbacksRef.current.forEach((callback) => callback(series));
        onReadyCallbacksRef.current = [];
      });
    }
  }, []);

  return {
    registerCallback,
    executeCallbacks,
  };
};
